import { Loader2, Sparkles } from "lucide-react";
import React from "react";
import { useTranslation } from "../../contexts/LanguageContext";
import VideoGenerationFields from "../video/VideoGenerationFields";
import Button from "../ui/Button";
import Modal from "../ui/Modal";
import { VideoTextItem } from "../../utils/videoGenerationRequest";

interface VideoGenerateModalProps {
  open: boolean;
  onClose: () => void;
  onGenerate: () => void;
  loadingGenerate: boolean;
  videoJobStatus?: "idle" | "pending" | "processing" | "completed" | "failed";
  postId: number | null;
  videoPrompt: string;
  setVideoPrompt: (prompt: string) => void;
  videoDuration: number;
  setVideoDuration: (duration: number) => void;
  videoRestrictions: string;
  setVideoRestrictions: (restrictions: string) => void;
  videoProvider: string;
  setVideoProvider: (provider: string) => void;
  logoFile: File | null;
  setLogoFile: (file: File | null) => void;
  logoPreview: string | null;
  setLogoPreview: (preview: string | null) => void;
  referenceImages: File[];
  setReferenceImages: (images: File[]) => void;
  referenceImagePreviews: string[];
  setReferenceImagePreviews: (previews: string[]) => void;
  videoTexts: VideoTextItem[];
  setVideoTexts: (texts: VideoTextItem[]) => void;
  videoScript: string;
  setVideoScript: (script: string) => void;
}

const VideoGenerateModal: React.FC<VideoGenerateModalProps> = ({
  open,
  onClose,
  onGenerate,
  loadingGenerate,
  videoJobStatus = "idle",
  postId,
  ...fields
}) => {
  const { t } = useTranslation();
  const generateButtonLabel = loadingGenerate
    ? videoJobStatus === "processing"
      ? t("Processando vídeo com IA...")
      : videoJobStatus === "pending"
        ? t("Na fila de geração...")
        : t("Gerando Vídeo...")
    : t("Gerar Vídeo com IA");

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t("Gerar Vídeo com IA - Post #{postId}", { postId: postId || "" })}
      maxWidth="max-w-3xl"
      footer={
        <div className="flex justify-end gap-3">
          <Button
            type="button"
            variant="secondary"
            onClick={onClose}
            disabled={loadingGenerate}
            size="sm"
          >
            {t("Cancelar")}
          </Button>
          <Button
            type="button"
            variant="primary"
            icon={
              loadingGenerate ? (
                <Loader2 className="w-4 h-4 animate-spin" />
              ) : (
                <Sparkles className="w-4 h-4" />
              )
            }
            onClick={onGenerate}
            disabled={loadingGenerate}
            size="sm"
          >
            {generateButtonLabel}
          </Button>
        </div>
      }
    >
      <VideoGenerationFields disabled={loadingGenerate} {...fields} />
    </Modal>
  );
};

export default VideoGenerateModal;
